import { Grupo } from "./../grupo/grupo.model";
import { Usuario } from "./../usuario/usuario.model";
import {UsuarioResumo} from './../usuario/usuario-resumo-model';
import { HorarioFuncionamento } from '../horario-funcionamento/horario-funcionamento.model';
import { CanalInatividadePeriodo } from './canal-inatividade-periodo.model';

export class CanalModel {
  id?: number;
  nome?: string;
  descricao?: string;
  ativo?: boolean;
  mensagemInatividade?: string;
  mensagemInatividadeFuncionamento?: string;
  usuarioCriacao?: Usuario;
  dataCriacao?: Date;
  usuarioAlteracao?: Usuario;
  dataAlteracao?: Date;
  grupo?: Grupo;
  operadores: Usuario[] = [];
  coordenadores: UsuarioResumo[] = [];
  templates: any[] = [];
  inatividadeAtiva?: boolean;
  horariosFuncionamento: HorarioFuncionamento[] = [];
  privado?: boolean
  externo?: boolean
  periodosInatividade: CanalInatividadePeriodo[] = [];

  constructor(id?: number, nome?: string, descricao?: string, ativo?: boolean, usuarioCriacao?: Usuario, dataCriacao?: Date, usuarioAlteracao?: Usuario, dataAlteracao?: Date, grupo?: Grupo, operadores?: Usuario[], coordenadores?: UsuarioResumo[], templates?: any[], mensagemInatividade?: string, mensagemInatividadeFuncionamento?: string, inatividadeAtiva?: boolean, horariosFuncionamento?: HorarioFuncionamento[], periodosInatividade?: CanalInatividadePeriodo[], privado?: boolean, externo?: boolean) {
    this.id = id;
    this.nome = nome;
    this.descricao = descricao
    this.ativo = ativo;
    this.mensagemInatividade = mensagemInatividade;
    this.mensagemInatividadeFuncionamento = mensagemInatividadeFuncionamento;
    this.inatividadeAtiva = inatividadeAtiva;
    this.usuarioCriacao = usuarioCriacao;
    this.dataCriacao = dataCriacao;
    this.usuarioAlteracao = usuarioAlteracao;
    this.dataAlteracao = dataAlteracao;
    this.grupo = grupo;
    if (operadores)
      this.operadores = operadores;
    if (coordenadores)
      this.coordenadores = coordenadores;
    if (templates)
      this.templates = templates;
    if (horariosFuncionamento)
      this.horariosFuncionamento = horariosFuncionamento;
    if (periodosInatividade)
      this.periodosInatividade = periodosInatividade;
    this.privado = privado
    this.externo = externo
  }
}
